<template>
    <section
            id="add-updates"
            class="step-content-slot"
            :class="{'from-edit': $route.path === '/edit-campaign'}">
        <div class="wizard-component container">
            <Heading
                    v-if="$route.path !== '/edit-campaign'"
                    title="Add your updates schedule"
                    description="Add your planned update dates and spots for each date to be able to send cross-promotion requests.  If you have CrossProm agreement outside of the platform please make sure to mark those spots as busy by clicking on the spot"
            />
            <div class="loading pt-5" v-if="loading">
                <Loader class="pt-5"/>
            </div>
            <div v-else>
                <div class="wizard-content" :style="schedule.length ? 'padding-top: 20px' : ''">
                    <div
                        class="wizard-spot-content d-flex justify-content-between align-items-center py-2"
                        v-for="(date, i) in schedule"
                        :id="`date-${i}-${date.date}`"
                        :key="`field-${date.date}-${date.count}-${i}`">
                        <div>
                            <DatePicker
                                v-if="date.spots.every(item=>item===null) && (!date.pendingSpots || date.pendingSpots && date.pendingSpots.length===0) && date.date.getTime() + 86400000 > Date.now()"
                                :value="date.date"
                                @change="date.date = $event"/>
                            <span v-else class="date-imitation">
                                {{date.date | formateDate}}
                                <img
                                    :src="ICON_DATE"
                                    alt="">
                            </span>
                        </div>
                        <div class="flex-grow-1">
                            <ul class="spots-list m-0 d-flex justify-content-start" :class="{disabled: date.date.getTime() + 86400000 < Date.now()}">
                                <li
                                    class="spot-item position-relative"
                                    v-for="(spot, index) in date.spots"
                                    :key="`spot-${index}`"
                                    :id="`spot-${index}`"
                                >
                                    <div
                                        v-if="!date.pendingSpots || (date.pendingSpots && date.pendingSpots.indexOf(index) === -1)"
                                        :data-busy="spot || false"
                                        :id="[spot ? 'busy-spot': 'free-spot']"
                                        @click="toggleBusy(spot, i, index)">
                                            <p class="m-0">
                                                {{ index + 1 }}
                                            </p>
                                    </div>
                                    <div
                                        v-else
                                        data-pending
                                        data-busy>
                                            <p 
                                                id="pending-spot"
                                                class="m-0">
                                                    {{ index + 1 }}
                                            </p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div
                            class="button-group position-relative"
                            v-if="date.date.getTime() + 86400000 > Date.now()">
                            <div class="remove_del d-flex justify-content-between">
                                <button
                                        v-if="date.spots.length > 1"
                                        @click="decrement(i)"
                                        id="remove-button"
                                        class="remove">
                                    <RemoveSpotIcon/>
                                </button>
                                <button
                                        v-if="date.spots.length < 5"
                                        @click="increment(i)"
                                        id="add-spot-button"
                                        class="add ml-auto">
                                    <AddSpotIcon/>
                                </button>
                            </div>
                            <div
                                v-if="date.spots.every(item=>item===null) && (!date.pendingSpots || date.pendingSpots && date.pendingSpots.length===0)"
                                class="del pr-2">
                                <button @click="removeDate(i)">
                                    <RemoveSpotsField id="remove-spot-field-button"/>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="add-updates-footer">
                    <div class=" d-flex align-items-center justify-content-between">
                        <div>
                            <p class="p1n c6 mb-0">Add date</p>
                        </div>
                        <div>
                            <md-datepicker
                                v-model="date"
                                id="date-picker-footer"
                                class="m-0 pt-0" 
                                md-immediately>
                                    <img 
                                        :src="ICON_DATE"
                                        alt="">
                            </md-datepicker>
                        </div>
                        <div>
                            <b-dropdown
                                    id="status-dropdown"
                                    :text="spotsCount + ' spots'"
                                    class="p1n w-100 h-100">
                                <b-dropdown-item
                                        v-for="spot in Array.from(Array(5).keys())"
                                        :id="`dropdown-item-${spot}`"
                                        :key="`dropdown-item-${spot}`"
                                        @click="spotsCount = spot + 1"
                                        class="p1n my-2 ml-2">
                                    {{ spot + 1 }} spots
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                        <div>
                            <button
                                class="c16 lab"
                                id="add-date-button"
                                @click="addDate">
                                    + Add
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { db, elasticQuery, ELASTIC_SEARCH_CP_REQUESTS_INDEX, DEFAULT_CAMPAIGN_COLLECTION } from '../../firebase.js'
    import { getData, getRef, getDataByDocId } from '../../firebaseCRUD';
    import moment from 'moment'
    import { message } from 'ant-design-vue'
    import DatePicker from '@/components/DatePicker'
    import { AddSpotIcon, RemoveSpotIcon, RemoveSpotsField } from '../Icons'
    import Heading from "../Theme/Heading";
    import _ from 'lodash'
    import Loader from "../Icons/Loader";
    import { ICON_DATE } from "../../constants";
    import {convertToUTC} from '../../core/filters/dates'


export default {
        name: 'AddUpdates',
        components: {
            DatePicker,
            AddSpotIcon,
            RemoveSpotIcon,
            RemoveSpotsField,
            Heading,
            Loader
        },
        props: {
            cardData: Object,
            model: {
                type: String,
                default: DEFAULT_CAMPAIGN_COLLECTION
            }
        },
        data: function () {
            return {
                date: moment().add(1, 'days').toDate(),
                spotsCount: 3,
                schedule: [],
                loading: false,
                ICON_DATE
            }
        },
        watch: {
            'schedule': 'onChange',
        },
        mounted: function () {
            this.getScheduleFromFirebase()
            this.onChange();
            this.$emit('setChildEvent', {
                next: this.changeEvent,
                prev: this.changeEvent
            });
        },
        filters: {
          formateDate(date){
              return moment(date).format("DD/MM/YYYY")
          }
        },
        methods: {
            getSpotsInfo(communicator){
                if(communicator.campaign === this.$route.query.id){
                    return {
                        update_date: communicator.update_date.seconds,
                        spot_position: communicator.spot_position
                    }
                }
                return false
            },
            async getPendingSpots(){

                let pendingSpots = [];

                // get all requests for the current campaign with a pending status
                const doc = await db.collection('CpRequests')
                    .where('campaigns', 'array-contains', this.$route.query.id)
                    .where('status', '==', 'pending')
                    .get();

                // get spots data from requests for both senders and receivers
                for(let i = 0; i < doc.docs.length; i++){
                    await doc.docs[i].ref.get().then(resp=>{
                        const sender = resp.data().sender;
                        if(sender.update_date.seconds*1000 >= moment(new Date()).startOf('day').valueOf()){
                            const spotInfoForSender = this.getSpotsInfo(sender);
                            if(spotInfoForSender){
                                pendingSpots.push(spotInfoForSender);
                            }
                        }
                        const receiver = resp.data().receiver;
                        if(receiver.update_date.seconds*1000 >= moment(new Date()).startOf('day').valueOf()){
                            const spotInfoForReceiver = this.getSpotsInfo(receiver);
                            if(spotInfoForReceiver){
                                pendingSpots.push(spotInfoForReceiver);
                            }
                        }
                    })
                }


                if(!pendingSpots.length) {
                    return null;
                }
                // filter pendingSpots for only unique values
                pendingSpots = pendingSpots
                    .map(spot => JSON.stringify(spot))
                    .filter((item,index,self) => self.indexOf(item) === index)
                    .map(spot => JSON.parse(spot));

                // making pending spots arrays grouped by update_date
                return   _.mapValues(
                    _.groupBy(pendingSpots, 'update_date'),
                    items => items.map(spotInfo => spotInfo.spot_position)
                );
            },
            async getScheduleFromFirebase() {

                this.loading = true;

                let schedule = []

                try {
                    const snapshot = await getData('updates', {
                        field: 'cid',
                        condition: '==',
                        value: this.$route.query.id
                    });

                    const pendingSpots = await this.getPendingSpots();

                    let keys = [];
                    if(pendingSpots){
                        keys = Object.keys(pendingSpots);
                    }

                    schedule = snapshot.docs.map(
                        date => {
                            const data = {
                                ...date.data(),
                                id: date.id,
                            }

                            if(keys.length && keys.indexOf(data.date.seconds) && pendingSpots[data.date.seconds]){
                                data.pendingSpots = pendingSpots[data.date.seconds];
                            }
                            data.date = moment.utc(
                                moment.unix(data.date.seconds)
                            ).toDate()

                            return data
                        }
                    )

                    schedule.sort(
                        (a, b) => a.date.getTime() - b.date.getTime()
                    )

                    this.schedule = schedule;
                    this.loading = false;
                } catch (e) {
                    console.error(e);
                }
            },

            async changeEvent() {

                let snapshot = await getData('updates', {
                    field: 'cid',
                    condition: '==',
                    value: this.$route.query.id
                })

                const batch = db.batch()
                snapshot.docs.forEach(doc => batch.delete(doc.ref))

                let dates = []

                for (let i = 0; i < this.schedule.length; i++) {
                    const ref = await getRef({ collection: 'updates', id: this.schedule[i].id});
                    const data = {...this.schedule[i]}
                    
                    delete data.id
                    delete data.pendingSpots;
                    data.cid = this.$route.query.id
                    
                    // keep UTC date
                    const date = convertToUTC(moment(data.date))
                    dates.push(date)
                    data.date = date

                    batch.set(
                        ref,
                        data,
                    )
                }

                dates = dates.sort((a, b) => a - b)

                const campaignRef = db.collection(this.model).doc(this.$route.query.id)

                batch.update(campaignRef, { 
                    update_dates: dates.length ? dates : null
                })

                await batch.commit();
                await this.getScheduleFromFirebase();
            },

            onChange () {
                this.$emit('showNext', this.schedule.length > 0);
            },
            async addDate () {
                const oldDate = moment(this.date).startOf('day').isBefore(
                    moment().startOf('day')
                )

                if (oldDate) {
                    return message.error('An update date should be scheduled on the future date!')
                }

                const existingDate = this.schedule.find(
                    date => this.$options.filters.formateDate(this.date) === this.$options.filters.formateDate(date.date)
                )

                if (existingDate) {
                    return message.error('Existing update date!')
                }

                if(!this.cardData){
                    return
                }

                let thumbnails = this.cardData.thumbnails

                if(!thumbnails) {
                    const collection = this.$route.path.includes('/wizard/add-updates') ? 'drafts' : (this.$route.query.model || 'campaigns')
                    let doc = await getDataByDocId({ 
                         collection,
                         id: this.$route.query.id
                    })
                    thumbnails = doc.data().thumbnails
                }

                this.schedule.push({
                    uid: this.$store.state.user.uid,
                    cid: this.$route.query.id,
                    cname: this.cardData.title,
                    cimage: thumbnails && thumbnails.small || this.cardData.image,
                    spotsCount: this.spotsCount,
                    date: this.date,
                    spots: new Array(this.spotsCount).fill(null),
                })

                this.schedule.sort(
                    (a, b) => a.date.getTime() - b.date.getTime()
                )

                this.date = moment(this.date).add(1, 'week').toDate()

                if(this.$route.name === 'Add updates') {
                    this.$ga.event('Add Wizard', 'Add Date', 'Step', 4)
                    this.$sendMixpanelEvent('Add Wizard', {
                        'Step Number': 4,
                        'Action': 'Add Date Clicked'
                    });
                }
            },
            removeDate: function (index) {
                this.schedule = this.schedule.filter(
                    (date, i) => i !== index
                )
            },
            toggleBusy: function (spot, dateIndex, spotIndex) {
                const schedule = [...this.schedule]

                if (spot) {
                    if (!spot.uid) {
                        schedule[dateIndex].spots[spotIndex] = null
                    }
                } else {
                    schedule[dateIndex].spots[spotIndex] = {
                        accepted: true
                    }
                }

                this.schedule = [...schedule]
            },
            decrement: function (dateIndex) {
                const schedule = [...this.schedule]
                const lastSpotInRow = schedule[dateIndex].spots[schedule[dateIndex].spots.length - 1];
                let errText = '';

                if(lastSpotInRow){
                    errText = "Can't remove a busy spot"
                } else if(schedule[dateIndex].pendingSpots && schedule[dateIndex].pendingSpots.indexOf(schedule[dateIndex].spots.length - 1) !== -1){
                    errText = "Can't remove a pending spot"
                }
                if(!errText) {
                    schedule[dateIndex].spots.pop();
                    this.schedule = schedule
                } else {
                    return message.error(errText)
                }
            },
            increment: function (dateIndex) {
                const schedule = [...this.schedule]
                schedule[dateIndex].spots.push(null)
                this.schedule = schedule
            },
        },
    }
</script>

<style lang="scss">
    #add-updates {
        div.md-field {

            &::before,
            &::after {
                display: none;
            }

            &.md-datepicker {
                min-height: 30px;
                max-width: 119px !important;

                i {
                    display: none;
                }

                img {
                    position: absolute;
                    left: 100%;
                    top: 50%;
                    transform: translate(-20px, -6px);
                    z-index: 1;
                }

                button {
                    display: none;
                }

                input {
                    width: 100%;
                    height: 30px !important;
                    border: 1px solid #F4F4F4 !important;
                    border-radius: 5px;
                    color: #333333;
                    font-size: 13px !important;
                    padding-left: 5px;
                    margin-left: 0 !important;
                    z-index: 2;

                }
            }
        }

        div#status-dropdown {

            border-radius: 5px;

            button {
                border: 1px solid #F4F4F4 !important;
                width: 115px;
                height: 28px;
                padding: 0;
                padding-left: 5px !important;
                font-size: 13px;
                text-align: left;
                color: #333333;
                box-shadow: none;
                background: white;

                &::after {
                    content: "";
                    border-top: 0.3em solid;
                    border-right: 0.2em solid transparent;
                    border-bottom: 0;
                    border-left: 0.2em solid transparent;
                    position: absolute;
                    left: 100%;
                    top: 50%;
                    transform: translate(-15px, -50%);
                }
            }

            ul {
                border-radius: 5px;
                border: 1px solid #F4F4F4;
                padding: 0;

                li {
                    a {
                        padding: 0;
                        color: #333333;

                        &:hover {
                            color: #000000;
                        }
                    }
                }
            }
        }
    }
</style>

<style scoped lang="scss">
    #add-updates {

        &.from-edit {
            min-height: 650px;

            .wizard-component {
                min-height: 650px;
                display: flex;
                flex-direction: column;

                .wizard-content {
                    max-height: 560px !important;
                    height: auto;
                }
                .add-updates-footer {
                    padding-top: 20px;
                }
            }
        }
        .wizard-component {
            .wizard-content {
                width: 525px;
                height: auto;
                max-height: 280px !important;
                border-top: 1px solid #F4F4F4;
                border-bottom: 1px solid #F4F4F4;
                overflow-y: auto;
                border-radius: 5px;

                .wizard-spot-content {
                    transition: 0.2s all ease;

                    &:hover {
                        background: #F9F9F9;
                    }

                    ul.spots-list {

                        li.spot-item {
                            width: 28px;
                            height: 28px;
                            border-radius: 50%;
                            background: #ffffff;
                            color: #0ACF97;
                            font-size: 13px;
                            text-align: center;
                            margin-right: 15px;
                            transition: all 0.3s ease;
                            cursor: pointer;
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            div{
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                border-radius: 50%;
                                height: 100%;
                                width: 100%;
                                border: 1px solid #0ACF97;

                                &:hover {
                                    box-shadow: 0 4px 4px #B8CDD7;
                                    &::after {
                                        background: #00000073;
                                        position: absolute;
                                        border-radius: 8px;
                                        min-width: 75px;
                                        color: #fff;
                                        top: -18px;
                                        left: -50px;
                                        font-size: 8px;
                                        text-align: center;
                                        line-height: 16px;
                                    }
                                }

                                &[data-busy] {
                                    background-color: #B8CDD7;
                                    border: 1px solid #B8CDD7;
                                    &:hover {
                                        &::after {
                                            content: 'Unmark busy spot';
                                        }
                                    }
                                    p {
                                    color: #fff;

                                    }
                                }
                                    &:not([data-busy]):hover {
                                        margin-top: -1px;
                                        &::after {
                                            content: 'Mark busy';
                                        }
                                    }


                            }

                        }

                        &.disabled{
                            pointer-events: none;
                            li{
                                div[data-pending] {
                                    background-color: #fff;
                                    border: 1px solid #0acf9757;
                                    color: #0ACF97
                                }
                            }
                        }
                        &:not(.disabled){
                            li{
                                div[data-pending] {
                                    background-color: #0acf9757;
                                    border: 1px solid #0acf9757;
                                    &:hover {
                                        &::after {
                                            content: 'Pending Spot';
                                        }
                                    }
                                }
                            }
                        }

                    }

                    img {
                        cursor: pointer;
                    }

                    .button-group {
                        width: 120px;
                        height: 25px;

                        div {
                            position: absolute;
                            &.remove_del {
                                width: 60px;
                                left: 0;

                                button {
                                    padding: 0;
                                    &.remove {
                                        left: 0;
                                    }
                                    &.add {
                                        right: 0;
                                    }
                                }
                            }
                            &.del {
                                right: 0;
                                button {
                                    padding: 0;
                                }
                            }
                        }
                    }
                }
            }

            .add-updates-footer {
                width: 525px;
                padding-top: 15px;

                button {
                    &:last-child {
                        width: 63px;
                        height: 28px;
                        background: #0ACF97;
                        border-radius: 3px;
                        transition: all 0.2s ease;
                    }
                }
            }

        }

        .date-imitation{
            width: 118px;
            display: flex;
            align-items: center;
            height: 30px;
            border: 1px solid #F4F4F4;
            border-radius: 5px;
            color: #333333;
            font-size: 13px;
            padding: 5px;
            margin-left: 0;
            z-index: 2;
            justify-content: space-between;

        }

    }
</style>